/* flow */
import React, { PureComponent } from 'react'
import Tooltip from 'antd/lib/tooltip'
import labels from './labels'
import {cellClassName, headerCellColspan, capitalize} from './globals'
import type {Lang, Mode} from './App'

type Props = {
  asc: boolean,
  sorter: ?Sorter,
  lang: Lang,
  width: number,
  grouped: 0 | 1,
  sort: (sorter: Sorter) => (e: SyntheticEvent<>)=> void,
  unselect: () => void,
  mode: Mode
}

const ufkListHeader = [
  {value: 'name',label: 'name', textAlign: 'left' },
  {value: 'code', label: 'code', textAlign: 'left' },
  {value: 'category', label: 'cat', textAlign: 'left' },
  {value: 'managerShort', label: 'man', textAlign: 'left' },
  {value: 'valuation', label: 'val', textAlign: 'right'}, 
  {value: 'd', label: 'd', textAlign: 'right' }, 
  {value: 'm', label: 'm', textAlign: 'right' },
  {value: 'q', label: 'q', textAlign: 'right' },
  {value: 'y', label: 'y', textAlign: 'right' },
  {value: 'y3', label: 'y3', textAlign: 'right' },
  {value: 'y5', label: 'y5', textAlign: 'right' },
  {value: 'risk', label: 'risk', textAlign: 'center' }
]

const pteListHeader = [
  //{value: 'name',label: 'name', textAlign: 'left' },
  //{value: 'valuation', label: 'val', textAlign: 'right'},
  {value: 'd', label: 'd', textAlign: 'center' },
  {value: 'm', label: 'm', textAlign: 'center' },
  {value: 'q', label: 'q', textAlign: 'center' },
  {value: 'hy', label: 'hy', textAlign: 'center' },
  {value: 'y', label: 'y', textAlign: 'center' },
  {value: 'y3', label: 'y3', textAlign: 'center' },
  {value: 'y5', label: 'y5', textAlign: 'center' },
  {value: 'ytd', label: 'ytd', textAlign: 'center' },
  {value: 'max', label: 'max', textAlign: 'center' }
]

const  listHeaderByMode = (mode: Mode) =>  {
  switch (mode) {
    case "pte": return pteListHeader;
    case "ufk": return ufkListHeader;
  }
}


export default class Header extends PureComponent<Props> {
  render() {
    const { sort, unselect, sorter, lang, asc, width, grouped, mode } = this.props
    return (
      <thead className="full-width ac-list__header">
        { mode === 'pte' && headerCellColspan(width) !== -1 && <tr className={'ac-list__header'}>
          <UnselectSortCell
            lang={lang}
            sort={sort}
            unselect={unselect}
          />          
          <th className="show sortable left aligned  show sortable" rowSpan="2">
            {labels[lang]['name'+ capitalize(mode)]}
          </th>    
          <th className="show sortable left aligned  show sortable" rowSpan="2">
            {labels[lang]['val'+ capitalize(mode)]}
          </th>                  
          <th colSpan={headerCellColspan(width) } 
          className={'center aligned csv header'}>{labels[lang]['returnRate']}</th>
          <th className={`csv ${cellClassName(width, 'csv')} center aligned`} rowSpan="2">
            CSV
          </th>          
        </tr>}
        { mode === 'pte' && <tr className={'center aligned csv ac-list__header_second'}>
          {(listHeaderByMode(mode)).map(({ value, label, textAlign }) =>
              <SorterCell
              key={value}
              value={value}
              textAlign={textAlign}
              className={`${grouped && label === 'cat' ? 'hide' : cellClassName(width, label)} sortable`}
              content={labels[lang][label + capitalize(mode)]}
              direction={sorter === value ? ( asc ? 'ascending' : 'descending') : null}
              sort={sort}
            />
          )}
        </tr>}
        { mode === 'ufk' && <tr>
          <UnselectSortCell
            lang={lang}
            sort={sort}
            unselect={unselect}
          />
          {(listHeaderByMode(mode)).map(({ value, label, textAlign }) =>
            <SorterCell
              key={value}
              value={value}
              textAlign={textAlign}
              className={`${grouped && label === 'cat' ? 'hide' : cellClassName(width, label)} sortable`}
              content={labels[lang][label + capitalize(mode)]}
              direction={sorter === value ? ( asc ? 'ascending' : 'descending') : null}
              sort={sort}
            />
          )}
          { mode === 'ufk' &&  <th className={`csv ${cellClassName(width, 'csv')} center aligned`}>
            CSV
          </th>}
        </tr>}
      </thead>
    )
  }
}

type SorterCellProps = {
  value: Sorter,
  textAlign: string,
  direction: 'ascending' | 'descending' | null,
  className: string,
  content: string,
  sort: (sorter: Sorter) => (e: SyntheticEvent<>)=> void,
}

class SorterCell extends PureComponent<SorterCellProps> {
  render () {
    const { sort, value, textAlign, direction, className, content } = this.props
    return (
      <th
        className={`${className} ${textAlign} aligned ${direction ? `${direction} sorted` : ''} show sortable`}
        onClick={sort(value)}>
        {content}
      </th>
    )
  }
}

type UnselectSortProps = {
  lang: Laneg,
  sort: (sorter: Sorter) => (e: SyntheticEvent<>)=> void,
  unselect: () => void
}

class UnselectSortCell extends PureComponent<UnselectSortProps> {
  unselect = () => {
    const { unselect } = this.props
    unselect()
  }
  render() {
    const { sort, lang } = this.props
    return (
      <th className="center aligned checkbox"  rowSpan="2">
        <Tooltip title={labels[lang].unselectAll}>
          <i 
            aria-hidden="true"
            className="remove link icon"
            onClick={this.unselect}>
          </i>
        </Tooltip>
        <Tooltip title={labels[lang].raiseSelected}>
          <i 
            aria-hidden="true"
            className="arrow up link icon"
            onClick={sort('checked')}>
          </i>
        </Tooltip>
      </th>
    )
  }
}





// WEBPACK FOOTER //
// ./src/ListHeader.js